import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { timesheetApi, taskApi, managerApi, leaveApi } from '../services/api';
import { Link } from 'react-router-dom';

export default function Dashboard() {
  const { user, isManager, isHR } = useAuth();
  const [stats, setStats] = useState({ totalHours: 0, status: '', pendingApprovals: 0, pendingLeaves: 0, myTasks: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      const [tsRes, taskRes] = await Promise.allSettled([
        timesheetApi.getWeek(today),
        taskApi.getMyTasks(),
      ]);

      let totalHours = 0, status = 'No timesheet';
      if (tsRes.status === 'fulfilled' && tsRes.value.data.success) {
        const ts = tsRes.value.data.data;
        totalHours = ts.totalHours || 0;
        status = ts.status || 'DRAFT';
      }

      let myTasks = 0;
      if (taskRes.status === 'fulfilled' && taskRes.value.data.success) {
        myTasks = (taskRes.value.data.data || []).length;
      }

      let pendingApprovals = 0;
      let pendingLeaves = 0;
      if (isManager || isHR) {
        try {
          const pendRes = await managerApi.getPending();
          if (pendRes.data.success) {
            pendingApprovals = (pendRes.data.data || []).length;
          }
        } catch (e) { /* ignore */ }
        try {
          let leaveRes;
          if (isHR) leaveRes = await leaveApi.getPendingHR();
          else leaveRes = await leaveApi.getPendingManager();
          if (leaveRes.data.success) {
            pendingLeaves = (leaveRes.data.data || []).length;
          }
        } catch (e) { /* ignore */ }
      }

      setStats({ totalHours, status, pendingApprovals, pendingLeaves, myTasks });
    } catch (err) {
      console.error('Dashboard load error:', err);
    }
    setLoading(false);
  };

  const getStatusBadge = (status) => {
    const map = {
      DRAFT: 'badge-gray',
      SAVED: 'badge-info',
      SUBMITTED: 'badge-warning',
      MANAGER_APPROVED: 'badge-success',
      HR_APPROVED: 'badge-success',
      MANAGER_REJECTED: 'badge-danger',
      HR_REJECTED: 'badge-danger',
    };
    return map[status] || 'badge-gray';
  };

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Welcome, {user?.fullName?.split(' ')[0]}</h1>
      </div>

      <div className="stats-grid">
        <Link to="/timesheet" style={{ textDecoration: 'none' }}>
          <div className="stat-card">
            <div className="stat-label">This Week</div>
            <div className="stat-value">{stats.totalHours}h</div>
            <div className="stat-sub">
              <span className={`badge ${getStatusBadge(stats.status)}`}>
                {stats.status.replace(/_/g, ' ')}
              </span>
            </div>
          </div>
        </Link>

        <Link to="/tasks" style={{ textDecoration: 'none' }}>
          <div className="stat-card">
            <div className="stat-label">My Tasks</div>
            <div className="stat-value">{stats.myTasks}</div>
            <div className="stat-sub">Active tasks assigned</div>
          </div>
        </Link>

        {(isManager || isHR) && (
          <Link to="/approvals" style={{ textDecoration: 'none' }}>
            <div className="stat-card">
              <div className="stat-label">Pending Approvals</div>
              <div className="stat-value">{stats.pendingApprovals + stats.pendingLeaves}</div>
              <div className="stat-sub">
                {stats.pendingApprovals} timesheet{stats.pendingApprovals !== 1 ? 's' : ''} · {stats.pendingLeaves} leave{stats.pendingLeaves !== 1 ? 's' : ''}
              </div>
            </div>
          </Link>
        )}

        <div className="stat-card">
          <div className="stat-label">Role</div>
          <div className="stat-value" style={{ fontSize: 20 }}>{user?.role}</div>
          <div className="stat-sub">{user?.teamName || 'No Team'}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3>Quick Actions</h3>
        </div>
        <div className="card-body" style={{ display: 'flex', gap: 12 }}>
          <Link to="/timesheet" className="btn btn-primary">Enter Timesheet</Link>
          <Link to="/tasks" className="btn btn-outline">View Tasks</Link>
          <Link to="/projects" className="btn btn-outline">Projects</Link>
          {(isManager || isHR) && (
            <Link to="/approvals" className="btn btn-warning">Review Approvals</Link>
          )}
        </div>
      </div>
    </div>
  );
}
